import { render } from "./importRecord.vue?vue&type=template&id=7806f571&scoped=true"
import script from "./importRecord.vue?vue&type=script&lang=js"
export * from "./importRecord.vue?vue&type=script&lang=js"

import "./importRecord.vue?vue&type=style&index=0&id=7806f571&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7806f571"]])

export default __exports__